import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Settings, Bell, TrendingDown } from 'lucide-react';
import { Button } from '../components/ui/button';
import { approaches } from '../data/mock';

const iconMap = {
  Activity,
  Settings,
  Bell,
  TrendingDown
};

export const Solutions = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Soluções
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Sistemas integrados para gestão técnica de edifícios, instalações e ativos.
            </p>
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-slate-900 mb-6">
                A Nossa Abordagem
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
                Desenvolvemos soluções que integram monitorização, controlo e otimização 
                de ativos técnicos, adaptadas às necessidades de cada projeto.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {approaches.map((approach) => {
                const Icon = iconMap[approach.icon];
                return (
                  <div key={approach.id} className="flex gap-6 p-8 bg-gray-50 rounded-2xl">
                    <div className="w-16 h-16 bg-brand-green/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Icon className="text-brand-green" size={32} />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-slate-900 mb-3">
                        {approach.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {approach.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">
              Quer Saber Mais?
            </h2>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed">
              Entre em contacto para discutirmos o seu projeto.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white px-10 transition-all duration-300 hover:scale-105">
                Pedir Contacto
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
